/*
 *供应商 s端路由器模块
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)
import routes from './routes'
import store from '@/store'
import { Message} from 'element-ui'
import * as tool from '../utils/tool'

const originalPush = VueRouter.prototype.push

VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const router = new VueRouter({
  mode:process.env.NODE_ENV=="development"?"hash":"history",
  routes
})

// 导航守卫
// 使用 router.beforeEach 注册一个全局前置守卫，判断用户是否登陆
router.beforeEach((to, from, next) => {
  tool.checkBrowser().then(result => {
    if (!result) {
      next('/403page');
    }
  });
  if(to.meta.requireAuth){
    let token = localStorage.getItem('token');
    if (token === 'null' || token === ''|| token === null) {
      Message.info("请重新登录");
      next('/login');
    } else {
      setNav(to.matched);
      next();
    }
  }else{
    setNav(to.matched);
     next();
  }
});

/**
 * 导航设定
 * @param matched 从导航守卫 to。matched 拿出
 */
function setNav(matched){
  var navs = new Array();
  if(matched==null||matched.length==0){
    navs.push("首页")
  }else{
    matched.forEach(function (item,index) {
      var pageName = item.meta.title||"";
      if(pageName!=""){
        navs.push(pageName);
      }
    })
  }
  //载入
  store.commit('setNavigation', navs);
}

//验证是不是360浏览器
// function is360Browser() {
//   return new Promise(function(resolve) {
//     fetch('chrome-extension://fjbbmgamncjadhlpmffehlmmkdnkiadk/css/content.css')
//       .then(response => {
//         if (response.ok) {
//           resolve(true); // 请求成功且状态码为 200
//         } else {
//           resolve(false); // 请求成功但状态码不是 200
//         }
//       }).catch(error => {
//       console.error('Fetch error:', error);
//       resolve(false);
//     });
//   });
// }
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js